import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OverlayModule, BlockScrollStrategy, ScrollStrategyOptions } from '@angular/cdk/overlay';

// import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-introduction',
  templateUrl: './introduction.component.html',
  styleUrls: ['./introduction.component.scss']
})
export class IntroductionComponent implements OnInit {

  res: any = "";
  submitted1 = false;
  mobilno: any;
  contenthide = true ;
  iphonecontenthide=true;
  successcontenthide = true;
  screenW: boolean;
  linebox: boolean;
  // dialog_1 :any;

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private dialog: MatDialog
    ,  public dialog_1: MatDialogRef<TemplateRef<any>>,public dialog_2: MatDialogRef<TemplateRef<any>>,
    public dialog_3: MatDialogRef<TemplateRef<any>>,public dialog_4: MatDialogRef<TemplateRef<any>>,
    public dialog_5: MatDialogRef<TemplateRef<any>>, private router: Router,private route: ActivatedRoute
    ){}

    loginPage(){
      //console.log("redirect to login page");
      this.router.navigateByUrl("/login")
    }

    DownloadPage(){
      this.router.navigateByUrl("/Download")

    }
    opencitrix(){
     window.open(environment.citrix);
    }

    refreshpage(){
      location.reload();
    }


  ngOnInit() {

    // if(!sessionStorage.getItem("pop-up")){  //first time screen popup
    // document.getElementById("tempB").click();
    // }
  }

  dismissmodal() {
    this.dialog.closeAll()
  }

  temporaryButton(popUp){
    this.dialog_1 =  this.dialog.open(popUp ,{
      panelClass: 'popUp-dialog-container',
      autoFocus :false,
      restoreFocus : true,
      role :'dialog',
      disableClose : true,

      // height:'200px'
      // padding-left: '17%';
      // padding-right: '17%';
      
    })
    sessionStorage.setItem("pop-up","yes");
  }

  openLink(url){
    console.log("Link : " +url);
    
     window.open(url, "_blank");
  }

}

